import { useEffect, useState } from 'react';
import { getWeather, isWeatherCacheFresh } from './components/getWeather';
import { Link } from 'react-router-dom';
import SafeImage from './components/SafeImage';
import './App.css';

function Header() {
  const [currentWeatherData, setCurrentWeatherData] = useState(null);

  const fetchWeather = async (force = false) => {
    try {
      const data = await getWeather({ force });
      if (data && data.current) {
        setCurrentWeatherData(data.current);
      } else {
        console.log('Weather data unavailable or in unexpected format');
      }
    } catch (error) {
      console.error('Error fetching weather data:', error);
    }
  };

  useEffect(() => {
    fetchWeather();
    const refreshVisibleWeather = () => {
      if (!document.hidden && !isWeatherCacheFresh()) fetchWeather();
    };
    const intervalId = setInterval(refreshVisibleWeather, 180000);
    document.addEventListener('visibilitychange', refreshVisibleWeather);
    window.addEventListener('online', refreshVisibleWeather);
    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', refreshVisibleWeather);
      window.removeEventListener('online', refreshVisibleWeather);
    };
  }, []);

  const handleWeatherClick = () => {
    fetchWeather(true);
  };

  return (
    <div className="Top-Header">
      <h1 className="Title">Island City News</h1>
      <Link to="/weather" onClick={handleWeatherClick}>
        {currentWeatherData ? (
          <h3 title={currentWeatherData.condition.text}>
            <SafeImage src={currentWeatherData.condition.icon} alt={currentWeatherData.condition.text} style={{ height: '40px', verticalAlign: 'middle' }} />
            {Math.round(currentWeatherData.temp_f)}°
          </h3>
        ) : (
          <h4> </h4>
        )}
      </Link>
    </div>
  );
}

export default Header;
